import { Outlet } from 'react-router-dom';
import { PropsWithChildren } from 'react';
import clsx from 'clsx';
import Header from 'components/header/Header';
import TabBar from 'components/tabBar/TabBar';
import NotificationMenuMobileLayout from 'components/topBarMenuModals/notificationMenu/NotificationMenuMobile';
import HamburgerMenuMobileLayout from 'components/topBarMenuModals/hamburgerMenu/HamburgerMenuMobile';
import { useVisibleContent } from 'providers/VisibleContent';
import { useIsTabletAndLess } from '../../hooks/media-query';

function ContentVariant({ visible, children }: PropsWithChildren<{ visible: boolean }>) {
  return <div className={clsx('flex-col flex-grow', visible ? 'flex' : 'hidden')}>{children}</div>;
}

export default function AuthorizedBackgroundWrapper() {
  const { visibleContent, setVisibleContent } = useVisibleContent();
  const isTabletAndLess = useIsTabletAndLess();

  return (
    <div className="bg-white min-h-screen w-full h-full flex flex-col justify-between pt-[46px] pb-[78px] md:pb-0">
      <Header />

      <ContentVariant visible={visibleContent === 'main'}>
        <Outlet />
      </ContentVariant>

      {isTabletAndLess && (
        <>
          <ContentVariant visible={visibleContent === 'notifications'}>
            <NotificationMenuMobileLayout />
          </ContentVariant>

          <ContentVariant visible={visibleContent === 'menu'}>
            <HamburgerMenuMobileLayout
              onPressItem={() => {
                setVisibleContent('main');
              }}
            />
          </ContentVariant>
        </>
      )}

      <TabBar />
    </div>
  );
}
